import { connect } from 'react-redux'

import { PartnerIcon } from 'components/icons'
import { getPartner, getHasPartner } from 'registry/reducers'

import SetupGoal from './setup-goal'

function getText(state) {
  const hasPartner = getHasPartner(state)
  if (hasPartner == null) {
    return 'Anyone else along for the ride?'
  }
  if (!hasPartner) {
    return 'You and baby are on this journey together.'
  }

  const partner = getPartner(state)
  return partner.firstName
    ? `${partner.firstName} is on this journey with you.`
    : 'Invite your partner to add items too.'
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <PartnerIcon alternate={ownProps.alternateIcon} />,
    text: getText(state),
  }
}

export default connect(mapStateToProps)(SetupGoal)
